import { Container } from '@mui/material';
import './Photography.scss';

const importImages = (r) => {
    return r.keys().map(r);
}

const images = importImages(require.context('../assets/Photography', false, /\.(png|jpe?g|svg)$/));

const Photography = () => {
    return (
        <Container>
            <h1 className="section-heading">
                Photography
                <h3 className="subheading">
                    <i>
                        Email for prints and pricing.
                    </i>
                </h3>
            </h1>
            <div className="grid">
                {images.map((image, index) => (
                    <div key={index} className="grid-item">
                        <a href="/">
                            <img
                                src={image}
                                alt={`Photography ${index + 1}`}
                                loading="lazy"
                            />
                        </a>
                    </div>
                ))}
            </div>
        </Container>
    )
}

export default Photography;
